const NAME = "MY_ANNOTATIONS_PAGE";

export default NAME;
